export class LinkConstants {
    static readonly FacebookMessage: string = 'https://m.me/102771354890940';
  }